import { baseConfig } from '@/domains/base';
import { folder } from '@/domains/detail/folder';
import { space } from '@/domains/detail/space';
import { featureConfig } from '@/domains/feature-config';
import { legalStatus } from '@/domains/legal-status';
import { user } from '@/domains/user';
import { utils } from '@/domains/utils';
import { container } from '@/inversify.config';
import { commentsModule } from '@/modules/comments-module/comments-module';
import { patentFoldersModule } from '@/modules/patent-folders-module/patent-folders-module';
import { ContainerModule } from 'inversify';
import { base } from './base';
import { infrastructure } from './infrastructure';
import { services } from './services';
import { aiTagging } from '@/domains/ai-tagging';
import { dataset } from '@/domains/detail/dataset';
import { folderList } from '@/domains/detail/folder-list';
import { selected } from '@/domains/detail/selected';
import { tableColumn } from '@/domains/detail/table-column';
import { localStorage } from '@/domains/local-storage';
import { userGuide } from '@/domains/user-guide';
import { layerFieldEditorModule } from '@/modules/layer-field-editor-module/layer-field-editor-module';
import { shareLinkModule } from '@/modules/share-link-module/share-link-module';
import { DetailViewTypeService, LocalStorageDetailViewTypeServiceImp } from '@/services/detail-view-name-service';
import { FieldSorterService, FieldSorterServiceImpl } from '@/services/field-sorter-service';
import { PatentViewTypeService, PatentViewTypeServiceImp } from '@/services/patent-view-type-service';
import { chemStructureModule } from '@/domains/chem-structure';
import { keywordSearchModule } from '@/domains/custom-field/keyword-search';
import { customFieldsModule } from '@/domains/custom-fields';
import { hiroModule } from '@/domains/hiro';
import { dataTypeActionModule } from '@/domains/data-type-action';
import { detailActions } from '@/domains/detail/actions';
import { pageSelector } from '@/domains/detail/page-selector';
import { toolbar } from '@/domains/detail/toolbar';
import { editingSpaceModule } from '@/domains/editing-space';
import { lazyLink } from '@/domains/lazy-link';
import { onboarding } from '@/domains/onboarding/';
import { shareSpace } from '@/domains/share-space';
import { spaceAdminModule } from '@/domains/space-admin/space-admin-module';
import { spaceGroupPermissionModule } from '@/domains/space-group-permission/space-group-permission-module';
import { spaceLabelsModule } from '@/domains/space-labels';
import { spaceRecentListModule } from '@/domains/space-recent-list';
import { operationRecords } from '@/domains/space-settings/operation-records';
import { spaceTagModule } from '@/domains/space-tag/space-tag-module';
import { spaceTemplatesModule } from '@/domains/space-templates';
import { spacesModule } from '@/domains/spaces/spaces-module';
import { utilServices } from '@/infrastructure/utils/util-services';
import { createReportModule } from '@/modules/create-report-module/create-report-module';
import { createSpaceModule } from '@/modules/create-space-module/create-space-module';
import { customFieldActionsModule } from '@/modules/custom-field-actions-module';
import { editSpaceModule } from '@/modules/edit-space-module/edit-space-module';
import { exportPaperModule } from '@/modules/export-paper-module';
import { leaveSpaceModule } from '@/modules/leave-space-module/leave-space-module';
import { patentImageModule } from '@/modules/patent-image-module';
import { pinSpaceModule } from '@/modules/pin-space-module';
import { removeSpaceModule } from '@/modules/remove-space-module/remove-space-module';
import { shareSpaceModule } from '@/modules/share-space-module/share-space-module';
import { templateLibraryModule } from '@/modules/template-library-module/template-library-module';
import { transferSpacesModule } from '@/modules/transfer-space-module/transfer-space-module';
import { ConfirmServiceImpl } from '@/services/confirm-service';
import { ConfirmService } from '@/services/confirm-service.interface';
container.load(base);
container.load(utils);
container.load(services);
container.load(infrastructure);
container.load(new ContainerModule(patentFoldersModule));
container.load(new ContainerModule(commentsModule));
container.load(baseConfig);
container.load(featureConfig);
container.load(user);
container.load(space);
container.load(folder);
container.load(legalStatus);
container.load(aiTagging);
container.load(userGuide);
container.load(new ContainerModule(layerFieldEditorModule));
container.load(new ContainerModule((bind) => {
    bind(FieldSorterService).to(FieldSorterServiceImpl);
    bind(DetailViewTypeService).to(LocalStorageDetailViewTypeServiceImp);
    bind(PatentViewTypeService).to(PatentViewTypeServiceImp);
}));
container.load(new ContainerModule(shareLinkModule));
container.load(dataset);
container.load(folderList);
container.load(localStorage);
container.load(tableColumn);
container.load(selected);
container.load(onboarding);
container.load(new ContainerModule(spacesModule));
container.load(new ContainerModule(spaceTagModule));
container.load(new ContainerModule(spaceAdminModule));
container.load(new ContainerModule(spaceTemplatesModule));
container.load(new ContainerModule(transferSpacesModule));
container.load(new ContainerModule(createSpaceModule));
container.load(new ContainerModule(removeSpaceModule));
container.load(new ContainerModule(leaveSpaceModule));
container.load(new ContainerModule(shareSpaceModule));
container.load(new ContainerModule(templateLibraryModule));
container.load(new ContainerModule(createReportModule));
container.load(new ContainerModule(editSpaceModule));
container.bind(ConfirmService).to(ConfirmServiceImpl);
container.load(utilServices);
container.load(new ContainerModule(spaceLabelsModule));
container.load(spaceRecentListModule);
container.load(keywordSearchModule);
container.load(new ContainerModule(spaceGroupPermissionModule));
container.load(new ContainerModule(editingSpaceModule));
container.load(new ContainerModule(pinSpaceModule));
container.load(operationRecords);
container.load(new ContainerModule(shareSpace));
container.load(new ContainerModule(patentImageModule));
container.load(new ContainerModule(customFieldsModule));
container.load(new ContainerModule(customFieldActionsModule));
container.load(new ContainerModule(chemStructureModule));
container.load(hiroModule);
container.load(lazyLink);
container.load(detailActions);
container.load(pageSelector);
container.load(toolbar);
container.load(new ContainerModule(dataTypeActionModule));
container.load(new ContainerModule(exportPaperModule));
